const actions = {
  SET_STATE: "setting/SET_STATE",
  DETAIL: "setting/DETAIL",
  UPDATE: "setting/UPDATE",
  GET_DATETIME: "setting/GET_DATETIME",
  SET_DATETIME: "setting/SET_DATETIME",
  SHUTDOWN: "setting/SHUTDOWN",
  FACTORY_RESET: "setting/FACTORY_RESET",
  EXPORT: "setting/EXPORT",
  IMPORT: "setting/IMPORT",
  FACTORY_RESET_STATUS: "setting/FACTORY_RESET_STATUS",
  DETAIL_ONLY_LAYOUT: "setting/DETAIL_ONLY_LAYOUT",
  CLEAR_DETAIL_ONLY_LAYOUT: "setting/CLEAR_DETAIL_ONLY_LAYOUT",
};

export default actions;
